(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woc-header"]) return;
  try {
    
document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.woc-menu[open]').forEach(m=>m.open=false)});document.addEventListener('click',e=>{document.querySelectorAll('.woc-menu[open]').forEach(m=>{if((!m.contains(e.target)||e.target.closest('a')))m.open=false})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woc-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('woc-home')){customElements.define('woc-home',class extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;const tabs=[...this.querySelectorAll('[role=tab]')];const select=tab=>{tabs.forEach(t=>{const on=t===tab;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!on})};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(index+1)%tabs.length;if(e.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();tabs[next].focus();select(tabs[next])}})})}})}

  } catch(e) { console.error(e); }
})();
})();
